import React, { useEffect } from "react";
import Dashboard from "../assets/images/svgs/dashboard.svg";

import Profile from "../assets/images/svgs/user.png";
import Loyalty from "../assets/images/svgs/loyalty.svg";
import Note from "../assets/images/svgs/note.svg";
import Payment from "../assets/images/svgs/payment.svg";
import Wallet from "../assets/images/svgs/wallet.svg";
import Refer from "../assets/images/svgs/refer 1.svg";
import Leader from "../assets/images/svgs/ranking.svg";
import Betting from "../assets/images/svgs/status-up.svg";
import Mission from "../assets/images/svgs/mission.png";
import Logout from "../assets/images/svgs/logout.png";
import Support from "../assets/images/svgs/support.png";
import Setting from "../assets/images/svgs/setting.png";
import Live from "../assets/images/casino-icons/Live.svg";
import Others from "../assets/images/casino-icons/Others.svg";
import Virtual from "../assets/images/casino-icons/Virtual.svg";
import Crash from "../assets/images/casino-icons/Crash-Games.svg";
import VirtualCasino from "../assets/images/casino-icons/VirtualCasino.svg";
import Slot from "../assets/images/casino-icons/SlotGames.svg";
import Lobby from "../assets/images/casino-icons/Lobby.svg";
import Table from "../assets/images/casino-icons/TableGames.svg";
import Bet from "../assets/images/casino-icons/bet.svg";
import Casual from "../assets/images/casino-icons/CasualGames.svg";
import Sports from "../assets/images/casino-icons/Sports.svg";
import Fish from "../assets/images/casino-icons/FishShooting.svg";
import Video from "../assets/images/casino-icons/video.svg";
import LivePopular from "../assets/images/casino-icons/LivePopular.svg";
import Mini from "../assets/images/casino-icons/MiniGames.svg";
import Arcade from "../assets/images/casino-icons/ArcadeGames.svg";
import Bing from "../assets/images/casino-icons/BingGame.svg";

import BgImage from "../assets/images/BG(1).jpeg";
import LoginCard from "../assets/images/Maskgroup.jpg";
import Login from "../assets/images/Group jackpot.png";
import SignUp from "../assets/images/login mask.png";
import LoginMask from "../assets/images/Groupdial.png";
import { useSelector } from "react-redux";
import termCondition from "../assets/images/casino-icons/terms-and-conditions.svg";
import kyc from "../assets/images/casino-icons/kyc.svg";
import privacy from "../assets/images/casino-icons/insurance.svg";
import responsibility from "../assets/images/casino-icons/responsibility.svg";
import sportBook from "../assets/images/casino-icons/strategy.svg";
import fairness from "../assets/images/casino-icons/shake-hands.svg";
import faq from "../assets/images/casino-icons/question.svg";
import blackJack from "../assets/images/casino-icons/card-game.svg";
import baccarat from "../assets/images/casino-icons/baccarat.svg";
import liveRoulette from "../assets/images/casino-icons/roulette.svg";
import lottery from "../assets/images/casino-icons/lottery.svg";
import videoSlot from "../assets/images/casino-icons/video.svg";
import poker from "../assets/images/casino-icons/poker.svg";
import roulette from "../assets/images/casino-icons/roulette1.svg";
import liveBlackJack from "../assets/images/casino-icons/black-jack1.svg";
import livePoker from "../assets/images/casino-icons/cards1.svg";
import gameShow from "../assets/images/casino-icons/game-show.svg";
import liveDealer from "../assets/images/casino-icons/dealer.svg";
import liveBaccarat from "../assets/images/casino-icons/poker-table.svg";
import dragonTiger from "../assets/images/casino-icons/slot-machine.svg";

export function useOutsideAlerter(ref, open, setOpen) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      const logoClass = event?.target?.className;
      if (logoClass && typeof logoClass !== "object") {
        if (logoClass?.indexOf("toggleIcon") !== -1) {
          setOpen(!open);
        } else if (ref?.current && !ref.current?.contains(event?.target)) {
          setOpen(open);
        }
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}

export const setCookies = (key, value) => {
  document.cookie = key + "=" + (value || "") + "; path=/";
};

export const getCookies = (key) => {
  const value = ("; " + document.cookie).split(`; ${key}=`).pop().split(";")[0];
  return value;
};

export const deleteCookies = (name) => {
  console.log("delete");
  document.cookie =
    name +
    "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; SameSite=Strict; Secure";
};

export let sidebarDrawerInit = false;

// export const handleSidebarDrawerInit = () => {
//   console.log(430,sidebarDrawerInit )
//   sidebarDrawerInit = !sidebarDrawerInit;
//   console.log(433,sidebarDrawerInit )
//   return sidebarDrawerInit;
// };

export const handleSidebarDrawerInit = () => {
  sidebarDrawerInit = !sidebarDrawerInit;
  return sidebarDrawerInit;
};

export const formatDate = (inputDate) => {
  const date = new Date(inputDate);
  const day = String(date.getDate()).padStart(2, "0"); // DD
  const month = String(date.getMonth() + 1).padStart(2, "0"); // MM
  const year = date.getFullYear(); // YYYY
  return `${day}-${month}-${year}`;
};

export const getReadableDate = (dateString) => {
  const inputDate = new Date(dateString);
  const today = new Date();

  // Normalize both dates to midnight for comparison
  const input = new Date(
    inputDate.getFullYear(),
    inputDate.getMonth(),
    inputDate.getDate()
  );
  const current = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );

  const diffTime = current - input; // difference in milliseconds
  const diffDays = diffTime / (1000 * 60 * 60 * 24);

  if (diffDays === 0) return "Today";
  if (diffDays === 1) return "Yesterday";

  // Return formatted date: e.g. Jun 28, 2025
  const options = { year: "numeric", month: "short", day: "numeric" };
  return inputDate.toLocaleDateString(undefined, options);
};

export const checkImageURL = (url) => {
  if (!url) return false;
  else {
    const pattern = new RegExp(
      "^https?:\\/\\/.+\\.(png|jpg|jpeg|bmp|gif|webp)$",
      "i"
    );

    return pattern.test(url);
  }
};
// Example usage:

export const sideBarList = [
  {
    label: "Profile Details",
    url: "profile-details",
    name: "profileDetails",
    img: (
      <img
        src={Profile}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    label: "Payment Details",
    url: "payment-details",
    name: "paymentDetails",
    img: (
      <img
        src={Payment}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    label: "Referral Earnings",
    url: "referral-earning",
    name: "referEarning",
    img: (
      <img src={Refer} alt="icon" width={22} height={22} className="svg-icon" />
    ),
  },
  {
    label: "Bonus",
    url: "bonus",
    name: "bonus",
    img: (
      <img src={Note} alt="icon" width={22} height={22} className="svg-icon" />
    ),
  },
  {
    label: "My Bets",
    url: "my-bets",
    name: "myBets",
    img: (
      <img src={Note} alt="icon" width={22} height={22} className="svg-icon" />
    ),
  },
  {
    label: "My Wallet",
    url: "wallet",
    name: "myWallet",
    img: (
      <img
        src={Wallet}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    label: "Betting Profit & Loss",
    url: "bet-profit-loss",
    name: "betProfitLoss",
    img: (
      <img
        src={Betting}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    label: "Leaderboard",
    url: "leaderboard",
    name: "leaderboard",
    img: (
      <img
        src={Leader}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    label: "Mission",
    url: "mission",
    name: "mission",
    img: (
      <img
        src={Mission}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    label: "Loyalty",
    url: "loyalty",
    name: "loyalty",
    img: (
      <img
        src={Loyalty}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
];

export const casinoIcons = [
  {
    img: (
      <img src={Live} alt="icon" width={22} height={22} className="svg-icon" />
    ),
  },
  {
    img: (
      <img
        src={Others}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    img: (
      <img
        src={Virtual}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    img: (
      <img src={Crash} alt="icon" width={22} height={22} className="svg-icon" />
    ),
  },
  {
    img: (
      <img
        src={VirtualCasino}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    img: (
      <img src={Slot} alt="icon" width={22} height={22} className="svg-icon" />
    ),
  },
  {
    img: (
      <img src={Lobby} alt="icon" width={22} height={22} className="svg-icon" />
    ),
  },
  {
    img: (
      <img src={Table} alt="icon" width={22} height={22} className="svg-icon" />
    ),
  },
  {
    img: (
      <img src={Bet} alt="icon" width={22} height={22} className="svg-icon" />
    ),
  },
  {
    img: (
      <img
        src={Casual}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    img: (
      <img
        src={Sports}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    img: (
      <img src={Fish} alt="icon" width={22} height={22} className="svg-icon" />
    ),
  },

  {
    img: (
      <img src={Video} alt="icon" width={22} height={22} className="svg-icon" />
    ),
  },
  {
    img: (
      <img
        src={LivePopular}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    img: (
      <img src={Mini} alt="icon" width={22} height={22} className="svg-icon" />
    ),
  },
  {
    img: (
      <img
        src={Arcade}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    img: (
      <img src={Bing} alt="icon" width={22} height={22} className="svg-icon" />
    ),
  },

  {
    img: (
      <img
        src={blackJack}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    img: (
      <img
        src={baccarat}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    img: (
      <img
        src={liveRoulette}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    img: (
      <img
        src={lottery}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    img: (
      <img
        src={videoSlot}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    img: (
      <img src={poker} alt="icon" width={22} height={22} className="svg-icon" />
    ),
  },
  {
    img: (
      <img
        src={roulette}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    img: (
      <img
        src={liveBlackJack}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    img: (
      <img
        src={livePoker}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    img: (
      <img
        src={gameShow}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    img: (
      <img
        src={liveDealer}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    img: (
      <img
        src={liveBaccarat}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    img: (
      <img
        src={dragonTiger}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
];

export const downSideBarList = [
  {
    label: "Settings",
    url: "",
    name: "setting",
    img: (
      <img
        src={Setting}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
    type: "dropdown",
    dropdown: [],
  },

  // {
  //   label: "Logout",
  //   url: "logout",
  //   name: "logout",
  //   img: (
  //     <img
  //       src={Logout}
  //       alt="icon"
  //       width={22}
  //       height={22}
  //       className="svg-icon"
  //     />
  //   ),
  // },
];

export const cmsSideBarList = [
  {
    label: "TERMS CONDITION",
    url: "cms/TERMS_CONDITION",
    name: "termsConditions",
    img: (
      <img
        src={termCondition}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    label: "RESPONSIBLE GAMING",
    url: "cms/RESPONSIBLE_GAMING",
    name: "responsibleGame",
    img: (
      <img
        src={responsibility}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    label: "PRIVACY POLICY",
    url: "cms/PRIVACY_POLICY",
    name: "privacyPolicy",
    img: (
      <img
        src={privacy}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    label: "SPORTSBOOK TERMS",
    url: "cms/SPORTSBOOK_TERMS",
    name: "sportsbookTerms",
    img: (
      <img
        src={sportBook}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
  {
    label: "FAQ",
    url: "cms/FAQ",
    name: "faq",
    img: (
      <img src={faq} alt="icon" width={22} height={22} className="svg-icon" />
    ),
  },
  {
    label: "KYC POLICY",
    url: "cms/KYC_POLICY",
    name: "kycPolicy",
    img: (
      <img src={kyc} alt="icon" width={22} height={22} className="svg-icon" />
    ),
  },
  {
    label: "FAIRNESS RNG METHODS",
    url: "cms/FAIRNESS_RNG_METHODS",
    name: "fairnessRng",
    img: (
      <img
        src={fairness}
        alt="icon"
        width={22}
        height={22}
        className="svg-icon"
      />
    ),
  },
];

export const Languages = [
  { label: "English", value: "en" },
  { label: "অসমীয়া", value: "as" }, // Assamese
  { label: "বাংলা", value: "bn" }, // Bengali
  // { label: "बर'", value: "brx" }, // Bodo
  { label: "डोगरी", value: "doi" }, // Dogri
  { label: "ગુજરાતી", value: "gu" }, // Gujarati
  { label: "हिन्दी", value: "hi" }, // Hindi
  { label: "ಕನ್ನಡ", value: "kn" }, // Kannada
  // { label: "کٲشُر", value: "ks" }, // Kashmiri
  // { label: "कोंकणी", value: "kok" }, // Konkani
  { label: "मैथिली", value: "mai" }, // Maithili
  { label: "മലയാളം", value: "ml" }, // Malayalam
  { label: "মৈতৈলোন", value: "mni" }, // Manipuri (Meitei)
  { label: "मराठी", value: "mr" }, // Marathi
  // { label: "नेपाली", value: "ne" }, // Nepali
  // { label: "ଓଡ଼ିଆ", value: "or" }, // Odia
  { label: "ਪੰਜਾਬੀ", value: "pa" }, // Punjabi
  // { label: "संस्कृत", value: "sa" }, // Sanskrit
  // { label: "ᱥᱟᱱᱛᱟᱲᱤ", value: "sat" }, // Santali
  // { label: "سنڌي", value: "sd" }, // Sindhi
  { label: "தமிழ்", value: "ta" }, // Tamil
  { label: "తెలుగు", value: "te" }, // Telugu
  { label: "اردو", value: "ur" }, // Urdu
];

export const SidebarStaticIcons = [
  Live,
  Others,
  Virtual,
  Crash,
  VirtualCasino,
  Slot,
  Lobby,
  Table,
  Bet,
  Casual,
  Sports,
  Fish,
  Video,
  LivePopular,
  Mini,
  Arcade,
  Bing,
];

export const LoginSignUpStaticImages = [
  BgImage,
  LoginCard,
  Login,
  SignUp,
  LoginMask,
];

export const usePreloadSelectors = () => {
  const casinoProviders = useSelector(
    (state) => state.config?.data?.casinoProviders || []
  );

  const gameItems = useSelector((state) => state.games?.gameList || []);
  const banners = useSelector((state) => state.config?.data?.banners || []);

  return { casinoProviders, gameItems, banners };
};
